var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLoginPage)?[_c('Nav'),_c('slide-bar'),_c('div',{staticClass:"content"},[_c('router-view')],1)]:_c('wd-login',{attrs:{"title":"豌豆公主入库管理后台"},on:{"login":_vm.login}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }